import { SystemFeature, SystemSetting } from 'src/app/models/appEnums';
import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { deepClone } from '../../../../helpers/utils';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { AlertService } from '../../../../shared/services/alert.service';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { getBenefitPlanEDITransmissions } from '../../../../core/store/benefitPlanEDI/benefitPlanEDI.action';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { BenefitPlanEDITransmissionModel } from '../../../../models/benefitPlanEDITransmissionModel';
import { tap } from 'rxjs';

@Component({
    selector: 'app-report-benefitPlanEDI',
    templateUrl: './report-benefitPlanEDI.component.html',
    styleUrls: ['./report-benefitPlanEDI.component.scss'],
    standalone: false
})
export class ReportBenefitPlanEDIComponent extends BaseComponent implements OnInit {
  filter: any = {  };
  list: PagingResultsModel<BenefitPlanEDITransmissionModel>;

  loadingList: boolean = true;

  fileNameFilter;
  carrierFilter;
  MotivHealthEnabled;
  SameraHealthEnabled;
  
  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;
  totalRecords = signal<number>(0);

  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(

      this.store.select(s => s.accountState.systemFeatureIDs).subscribe(systemFeatureIDs => {
        this.MotivHealthEnabled = systemFeatureIDs && !!systemFeatureIDs.find(p => p === SystemFeature.MotivHealth);
        this.SameraHealthEnabled = systemFeatureIDs && !!systemFeatureIDs.find(p => p === SystemFeature.SameraHealth);
      }),

      this.store.select(s => s.benefitPlanEDIState.loadingTransmissions).subscribe(loading => {
        this.loadingList = loading;
      }),
      this.store.select(s => s.benefitPlanEDIState.transmissions).subscribe(list => {
        this.list = list;
        if(list != null)
          this.totalRecords.set(list.totalRecords);
      }),
    );

    this.dateRangeList = this.dropdownFilterService.getLast120DayDateRanges();
    if (this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }

    
  }  

  changedDateRange() {
    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadList(this.filter);
  }

  changedFilters() {
    this.reloadList(this.filter);
  }


  reloadList(event) {
    this.filter = event;
    this.filter = deepClone(this.filter || { filters: {} });
    this.filter.filters.fileNameFilter = { Name: 'FileName', Value: { value: this.fileNameFilter }, MatchMode: 'contains' };
    this.filter.filters.carrierFilter = { Name: 'Carrier', Value: { value: this.carrierFilter }, MatchMode: 'contains' };
    this.filter.filters.startDate = { Name: 'DateSent', Value: { value: this.startDate }, MatchMode: 'gte' };
    this.filter.filters.endDate = { Name: 'DateSent', Value: { value: this.endDate }, MatchMode: 'lte'  };
    
    this.store.dispatch(getBenefitPlanEDITransmissions({
      filter: this.filter
    }));
  }

}
